import React from "react";
import MathJax from "react-mathjax2";

const Viewer = ( props ) => {

  return (
    <div style={ { float : 'left', width : '40%' } }>
      <MathJax.Node>{ props.children }</MathJax.Node>
    </div>
  );

};

export default Viewer;
